var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2354H23.6471V19.4118H12V16.2354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1177 12H21.5294V14.1176H14.1177V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4707 45.8828H45.8825V48.0005H38.4707V45.8828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7061 26.8232H36.3531V29.9997H24.7061V26.8232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.353 40.5879H48.0001V43.7644H36.353V40.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8236 37.9411C26.8236 39.4007 25.6361 40.5881 24.1765 40.5881C22.7169 40.5881 21.5294 39.4007 21.5294 37.9411V21.5293H14.1177V37.9411C14.6235 51.2673 33.7317 51.2633 34.2353 37.9409V32.1175H26.8236V37.9411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2355 21.5297C34.2355 20.3621 35.1855 19.4121 36.3531 19.4121C37.5208 19.4121 38.4708 20.3621 38.4708 21.5297V38.4709H45.8826V21.5297C45.4034 8.90475 27.3008 8.90871 26.8237 21.5299C26.8237 21.5297 26.8237 24.7062 26.8237 24.7062H34.2355V21.5297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon_02.85147aef260a1fd7b5237d9a0e20c60f.svg";
export { ForwardRef as ReactComponent };